import React, {useState, createContext, useContext} from 'react';
import { ulid } from 'ulid';
import Callback from '../../Services/Callback';

const DialoguesContext = createContext();

export const useDialoguesContext = () => {
    return useContext(DialoguesContext);
};

export default ({children}) => {
    const [dialogues, setDialogues] = useState([]);
    const [isDialogueOpen, setIsDialogueOpen] = useState(false);

    const removeDialogue = (id) => {
        setDialogues(dials => {
            console.log('clearing', id, dials)
            const newDialogues = dials.filter(n => n.id !== id)
            setIsDialogueOpen(newDialogues.length > 0);

            return newDialogues;
        });
    }

    const showDialog = (type, options, callback) => {
        const id = ulid();
        let resolve, reject = null;
        const promise = new Promise((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });

        setIsDialogueOpen(true);
        setDialogues(dials => [
            ...dials,
            {id, type, options, callback, promise: [resolve, reject], remove: () => removeDialogue(id)}
        ]);

        return promise;
    }

    const showConfirm = (options, callback) => {
        return showDialog('confirm', options, callback);
    }

    const showInfo = (options) => {
        return showDialog('info', options);
    }

    const showFeatureUnavailable = (feature) => {
        return showDialog('featureUnavailable', {feature});
    }

    const showRoleInsufficient = (role) => {
        return showDialog('roleInsufficient', {role});
    }

    const showWorking = (options) => {
        const closer = new Callback();
        showDialog('working', options, closer);

        return () => closer.invoke();
    }

    const providerValues = {
        confirm: showConfirm,
        info: showInfo,
        working: showWorking,
        featureUnavailable: showFeatureUnavailable,
        roleInsufficient: showRoleInsufficient,
        dialogues,
        isDialogueOpen,
    };

    return <DialoguesContext.Provider value={providerValues}>
        {children}
    </DialoguesContext.Provider>
}
